import { render, staticRenderFns } from "./RoundaboutRight.vue?vue&type=template&id=10a482f6&scoped=true"
import script from "./RoundaboutRight.vue?vue&type=script&lang=js"
export * from "./RoundaboutRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a482f6",
  null
  
)

export default component.exports